// Flattens the nested navigation `menu` into a flat list of navigable leaf
// items so a global search (e.g. the Spotlight palette) can scan everything at
// once. Labels are kept raw here and translated by the caller, which keeps this
// function pure and cheap to memoize.
//
// Each entry: { label, parentLabel, group, href }

const toHref = (view) =>
  view ? `/view/${view.split('/')[0]}/${view.split('/')[1]}` : null;

const flattenMenu = (menu) => {
  if (!menu) {
    return [];
  }

  const result = [];

  menu.forEach((item) => {
    // The user dropdown holds account actions (logout, profile), not pages.
    if (item.user || item.name === 'user') {
      return;
    }

    // Top-level entry that links directly to a view (no sub-items).
    if (!item.items) {
      if (item.view) {
        result.push({
          label: item.label,
          parentLabel: null,
          group: null,
          href: toHref(item.view),
        });
      }
      return;
    }

    if (item.items.groups) {
      Object.keys(item.items.groups).forEach((group) => {
        item.items.groups[group].forEach((subItem) => {
          result.push({
            label: subItem.label,
            parentLabel: item.label,
            group,
            href: subItem.href || toHref(subItem.view),
          });
        });
      });
    }

    if (item.items.noGroup) {
      item.items.noGroup.forEach((subItem) => {
        result.push({
          label: subItem.label,
          parentLabel: item.label,
          group: null,
          href: subItem.href || toHref(subItem.view),
        });
      });
    }
  });

  return result.filter((entry) => entry.href);
};

export default flattenMenu;
